<template>
<div class="list">
  <div class="item left">
    <div class="pic"><img src="@/assets/img/about/icon-section-01.png"></div>
    <div class="name">橡诺的使命</div>
    <div class="sub">让技术更简单</div>
  </div>
  <div class="item right">
    <div class="pic"><img src="@/assets/img/about/icon-section-02.png"></div>
    <div class="name">橡诺的价值观</div>
    <div class="sub">创新进取、团队合作、激情奋斗</div>
  </div>
</div>
</template>

<script>
export default {
  name: ''
}
</script>

<style scoped lang="less">
.list{
  width: 100%;
  padding: 150px 0 80px 0;
  font-size: 0;
  .item{
    position: relative;
    width: 50%;
    display: inline-block;
    vertical-align: top;
    text-align: center;
    box-sizing: border-box;
    .pic{
      position: relative;
      box-sizing: border-box;
      overflow: hidden;
      width: 100px;
      height: 100px;
      margin: auto;
      img{
        width: 100%;
        vertical-align: middle;
      }
    }
    .name{
      font-size: 24px;
      color: #404040;
      padding: 20px 0;
    }
    .sub{
      margin: 0 auto;
      width: 90%;
      font-size: 32px;
      color: #404040;
    }
  }
  .left{
    padding-left: 5%;
    background: url(../assets/img/about/icon-section-01-bg.png) no-repeat center center;
    background-size: 85%;
    &:after {
      content: '';
      position: absolute;
      top: 50%;
      right: 0;
      width: 1px;
      height: 340px;
      margin-top: -170px;
      background: #bfbfbf;
    }
  }
  .right{
    padding-right: 5%;
    background: url(../assets/img/about/icon-section-02-bg.png) no-repeat center center;
    background-size: 85%;
  }
}
</style>
